// ... existing code ...
const hubs = [
  {
    icon: 'ri-compass-3-line',
    label: 'Seasonal Guides',
    tagline: 'Plan your season without the overwhelm',
    desc: 'Find the best local camps for every age and budget — all curated for Gwinnett families.',
    link: 'https://gwinnettcampguide.com',
    linkText: 'Explore Guides',
    image: 'https://public.readdy.ai/ai/img_res/aff23465500beb63dc8a806b173c1fab.jpg',
    accent: 'bg-amber-50 border-amber-100',
    badge: 'bg-amber-100 text-amber-700',
    btn: 'bg-amber-500 hover:bg-amber-600 text-white',
    external: true,
  },
  {
    icon: 'ri-duck-line',
    label: 'What The Duck',
    tagline: 'A local scavenger hunt your kids will be obsessed with',
    desc: 'Discover hidden ducks across Gwinnett County and submit your finds to the community map.',
    link: '/whattheduck',
    linkText: 'Join the Hunt',
    image: 'https://readdy.ai/api/search-image?query=children%20exploring%20outdoors%20on%20a%20treasure%20hunt%20adventure%20laughing%20discovering%20hidden%20objects%20in%20a%20Georgia%20neighborhood%20park%20sunny%20day%20family%20fun%20community%20activity&width=800&height=600&seq=hub_duck_v1&orientation=landscape',
    accent: 'bg-rose-50 border-rose-100',
    badge: 'bg-rose-100 text-rose-600',
    btn: 'bg-pink-600 hover:bg-pink-700 text-white',
    external: false,
  },
  {
    icon: 'ri-heart-2-line',
    label: 'Local Resources',
    tagline: 'Real help, right here when you need it',
    desc: 'Food support, family services, health resources, and emergency help — all in one place.',
    link: '/local-resources',
    linkText: 'Find Resources',
    image: 'https://readdy.ai/api/search-image?query=warm%20supportive%20community%20center%20interior%20with%20welcoming%20atmosphere%20resource%20materials%20on%20tables%20friendly%20inviting%20space%20families%20gathering%20local%20support%20Georgia%20neighborhood&width=800&height=600&seq=hub_resources_v1&orientation=landscape',
    accent: 'bg-emerald-50 border-emerald-100',
    badge: 'bg-emerald-100 text-emerald-700',
    btn: 'bg-emerald-600 hover:bg-emerald-700 text-white',
    external: false,
  },
];

export default function ExploreHub() {
  return (
    <section className="py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20">
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4 block">
            Explore The Hub
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Everything you need.<br />All in one place.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {hubs.map((hub) => (
            <div
              key={hub.label}
              className={`rounded-2xl border overflow-hidden flex flex-col ${hub.accent}`}
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={hub.image}
                  alt={hub.label}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/20" />
              </div>

              <div className="p-7 flex flex-col flex-1">
                <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold mb-4 self-start ${hub.badge}`}>
                  <i className={`${hub.icon} text-sm`}></i>
                  {hub.label}
                </span>
                <h3 className="text-xl font-extrabold text-gray-900 mb-3 leading-snug">
                  {hub.tagline}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-7 flex-1">
                  {hub.desc}
                </p>
                {hub.external ? (
                  <a
                    href={hub.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${hub.btn}`}
                  >
                    {hub.linkText}
                    <i className="ri-external-link-line"></i>
                  </a>
                ) : (
                  <Link
                    to={hub.link}
                    className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${hub.btn}`}
                  >
                    {hub.linkText}
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
